import { render, staticRenderFns } from "./shop-add-channel-dialog.vue?vue&type=template&id=69f284fc&scoped=true"
import script from "./shop-add-channel-dialog.vue?vue&type=script&lang=js"
export * from "./shop-add-channel-dialog.vue?vue&type=script&lang=js"
import style0 from "./shop-add-channel-dialog.vue?vue&type=style&index=0&id=69f284fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f284fc",
  null
  
)

export default component.exports